import { SectorModel } from "types";

// Sector Backgrounds
import bgFixedImageCrownlock from "assets/bg-fixed-crownlock.png";
import bgMovingImageCrownlock from "assets/bg-moving-crownlock.png";
import bgSlowImageCrownlock from "assets/bg-slow-crownlock.png";
import fgImageCrownlock from "assets/fg-crownlock.png";
import bgShipTramContraImage from "assets/bg-ship-tram-contra.png";
import bgShipTransporterContraImage from "assets/bg-ship-transporter-contra.png";

// Background Ships

const CONTRA_SECTORS: Record<string, SectorModel> = {
  skylock: {
    slug: "skylock",
    name: "Skylock",
    planet: "contra",
    backgroundFixedImage: bgFixedImageCrownlock,
    backgroundSlowImage: bgSlowImageCrownlock,
    backgroundMovingImage: bgMovingImageCrownlock,
    foregroundImage: fgImageCrownlock,
    backgroundFixedShips: [
      {
        image: bgShipTramContraImage,
        duration: 15,
        height: 6,
        verticalPosition: 70,
        isMovingRight: true,
      },
      {
        image: bgShipTransporterContraImage,
        duration: 12,
        height: 6,
        verticalPosition: 40,
        isMovingRight: false,
      },
    ],
    backgroundSlowShips: [
      {
        image: bgShipTramContraImage,
        duration: 35,
        height: 10,
        verticalPosition: 30,
        isMovingRight: true,
      },
      {
        image: bgShipTransporterContraImage,
        duration: 30,
        height: 10,
        verticalPosition: 60,
        isMovingRight: true,
      },
      {
        image: bgShipTramContraImage,
        duration: 38,
        height: 10,
        verticalPosition: 80,
        isMovingRight: false,
      },
    ],
    backgroundMovingShips: [
      {
        image: bgShipTransporterContraImage,
        duration: 21,
        height: 18,
        verticalPosition: 65,
        isMovingRight: true,
      },
      {
        image: bgShipTramContraImage,
        duration: 26,
        height: 18,
        verticalPosition: 25,
        isMovingRight: false,
      },
      {
        image: bgShipTramContraImage,
        duration: 24,
        height: 18,
        verticalPosition: 50,
        isMovingRight: true,
      },
    ],
    npcs: [],
    mobs: [],
    buildings: ["contraShipworks", "contraJumpGate", "contraPilotAcademy"],
    shipworks: "contraShipworks",
    moveRange: 180,
    areaLeft: null,
    areaRight: null,
  },
};

export default CONTRA_SECTORS;
